import React, { useEffect } from 'react';
import logo from "../../assets/icons/logo.png";

import axios from 'axios';
import { toastify } from '../../components/Toast';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from "react-router-dom";
import '@fortawesome/react-fontawesome';
import '@fortawesome/free-regular-svg-icons';

function LoginWithEmail() {
    const navigate = useNavigate();
    const [Email, setEmail] = React.useState("");
    const [Submit, setSubmit] = React.useState(false);
    React.useState(false);
    const urlSearchParams = new URLSearchParams(window.location.search);

    useEffect(() => {
        // Prefill only when the form mounts; rerenders must keep typed input.
        const initialEmail = new URLSearchParams(window.location.search).get('email');
        if (initialEmail) setEmail(initialEmail);
    }, []);
    if (urlSearchParams.get('expire') && urlSearchParams.get('email')) {
        // SetExpire(true);
    }
    function changeTxt(event) {
        setEmail(event.target.value);
    }
    const handleSubmit = async (e) => {
        // /setLoading(true);
        e.preventDefault();
        setSubmit(true);
        const data = {
            email: e.target.email.value
        }

        try {
            await axios.post(`${process.env.REACT_APP_API}users/create-magic-link`, data);
             // Debugging: Log the response
            setEmail("");
            setSubmit(false);
            // toastify("success", response.data.message);
            // navigate(`/token_waiting`);
            navigate('/token_waiting', {
                state: {
                    email: e.target.email.value,
                    // any other values you want to pass
                }
            });
        } catch (err) {
            console.error(err.response);
            setEmail("");
            setSubmit(false);
            if (err.response) {
                err.response.data.message = (err.response.data.message === 'Please enter a valid email address') ? 'Please enter a valid account email address' : err.response.data.message;
                toastify("error", err.response.data.message);
            } else {
                console.error(err.message); // Log any other errors that don't have a response object
                toastify("error", "An error occurred");
            }
        };
    };
    return (
        <>
            <div className="loginHolder bg-[#F3F4F6] min-h-[100vh] flex items-center">
                <div className="formHolder bg-white md:w-1/2 lg:w-2/5 max-w-lg mx-auto my-5 p-8 rounded-lg shadow border-auth">
                    <div className="logo">
                        <img alt="Zimzee" src={logo} className="logo-centered" />
                    </div>
                    <h3 className="text-xl mt-7 mb-6 font-bold text-[24px] text-center">Sign in to Zimzee</h3>
                    <form className="loginForm flex flex-col" onSubmit={handleSubmit}>
                        {
                            urlSearchParams.get('expire') && urlSearchParams.get('email') && (
                                <>
                                    <div class="bg-white shadow-lg rounded-md border border-coolGray-150 mt-5" data-test-id="static_alert">
                                        <div class="p-4">
                                            <div class="flex items-start">
                                                <div class="flex-shrink-0">
                                                    <i class="far fa-check-circle text-green-400 text-xl inline-block" aria-hidden="true"></i>
                                                </div>
                                                <div class="ml-3 w-0 flex-1 pt-1">
                                                    <p class="text-sm font-medium text-gray-900" id="alert-message">

                                                        Expired or Invalid Link - Request a new Magic Link or Login

                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="bg-white shadow-lg rounded-md border border-coolGray-150 mt-5" data-test-id="static_alert">
                                        <div class="p-4">
                                            <div class="flex items-start">
                                                <div class="flex-shrink-0 pt-0.5">
                                                    <svg className="text-red-400 w-5 h-5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                        <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="2" />
                                                        <line x1="12" y1="8" x2="12" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                                                        <circle cx="12" cy="16" r="1" fill="currentColor" />
                                                    </svg>
                                                </div>
                                                <div class="ml-3 w-0 flex-1 pt-0.5">
                                                    <p class="text-sm font-medium text-gray-900" id="alert-message">

                                                        Invalid credentials.

                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )
                        }


                        {/* style={{borderColor:"#D9D9D9 !important", borderWidth: '1px'}} */}
                        <input className="border-2 border-[#D9D9D9] bg-white my-3 p-3 rounded-md" type="email" id="email" onChange={changeTxt} value={Email} placeholder="Your Email" />
                        <button type="submit" disabled={Submit} className="button bg-[#FF6600] text-white py-2 rounded-[5px] mt-4">{Submit ? 'Loading...' : 'Continue'}</button>
                        <div className="remember w-full my-4 text-right">
                            <a className="text-[#394150] text-blue-600 font-semibold hover:underline" href="/login">Sign in with Password</a>
                        </div>
                    </form>
                    {/* <p className="text-center pt-3 pb-5">A one click password-free login link will be emailed to you.</p>
                <div className="mt-4 text-center">
                    <hr className="-mb-3 border-[#394150]" />
                    <span className="inline-block bg-white text-center text-[#394150] px-3">OR</span>
                </div>
                <a href="/" type="button" className="flex justify-center py-3 mt-7" style={{border:"1px solid #D9D9D9", borderRadius: "50px",width:"100%"}}>
                    <img className="pr-3" src={magicLinkIcon} />
                    <span className="font-bold">Login with Password</span>
                </a> */}
                    <h4 className="text-gray-500 text-center mt-12">First time here? <a className="text-[#5587e9] text-blue-600 font-semibold hover:underline" href="https://zimzee.com">Create account</a></h4>
                </div>
            </div>
            <ToastContainer />
        </>
    );
}

export default LoginWithEmail;
